import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { copilotConfigurationRows } from '../../data/mockBackedAdapters'
import { MOCK_BACKED_AREAS, buildMockGap } from '../../data/reportModel'
import MockedPanel from '../../components/MockedPanel/MockedPanel'
import ReportTable from '../../components/ReportTable/ReportTable'
import SubBlock from '../../components/SubBlock/SubBlock'

export default function CopilotConfiguration({ dataAvailability }) {
  const gap = buildMockGap(dataAvailability, MOCK_BACKED_AREAS.COPILOT_CONFIGURATION)
  const columns = [
    {
      key: 'setting',
      header: <FormattedMessage id="AI_RISK_REPORT.COL.CONTROL" />,
      render: (row) => <code>{row.setting}</code>,
      sortable: true,
      sortValue: (row) => row.setting,
    },
    {
      key: 'current',
      header: <FormattedMessage id="AI_RISK_REPORT.SETTINGS.COL_CURRENT" />,
      render: (row) => row.current,
      sortable: true,
      sortValue: (row) => row.current,
    },
    {
      key: 'recommended',
      header: <FormattedMessage id="AI_RISK_REPORT.SETTINGS.COL_RECOMMENDED" />,
      render: (row) => row.recommended,
      sortable: true,
      sortValue: (row) => row.recommended,
    },
  ]

  return (
    <SubBlock
      titleId="AI_RISK_REPORT.DEPLOYMENT.COPILOT_CONFIG.TITLE"
      subtitleId="AI_RISK_REPORT.DEPLOYMENT.COPILOT_CONFIG.SUBTITLE"
      mocked
      hideFromExport
    >
      <MockedPanel gap={gap}>
        <ReportTable columns={columns} rows={copilotConfigurationRows} />
      </MockedPanel>
    </SubBlock>
  )
}

CopilotConfiguration.propTypes = { dataAvailability: PropTypes.arrayOf(PropTypes.shape({})).isRequired }
